module.exports = __webpack_public_path__ + "img/domains-step-4.ru.034ee57e.png";